var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.463,
    height: 40.618,
    viewBox: "0 0 30.463 40.618",
    fill: "#0a579b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(-204.018 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-earmark-post",
    transform: "translate(202.018 456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M32.463,11.424V35.541a5.077,5.077,0,0,1-5.077,5.077H7.077A5.077,5.077,0,0,1,2,35.541V5.077A5.077,5.077,0,0,1,7.077,0H21.04Zm-7.616,0A3.808,3.808,0,0,1,21.04,7.616V2.539H7.077A2.539,2.539,0,0,0,4.539,5.077V35.541a2.539,2.539,0,0,0,2.539,2.539H27.386a2.539,2.539,0,0,0,2.539-2.539V11.424Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M4,11.885a1.269,1.269,0,0,1,1.269-1.269H23.04a1.269,1.269,0,0,1,1.269,1.269v17.77a1.269,1.269,0,0,1-1.269,1.269H5.269A1.269,1.269,0,0,1,4,29.656ZM4,4.269A1.269,1.269,0,0,1,5.269,3h6.347a1.269,1.269,0,0,1,0,2.539H5.269A1.269,1.269,0,0,1,4,4.269Z",
    transform: "translate(3.077 4.616)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.c2990445f9f26b60196708b7120e45ce.svg";
export { ForwardRef as ReactComponent };